const o=["ES","FR"];export{o as ALLOWED_COUNTRIES};
//# sourceMappingURL=config.js.map
